import {Component, OnInit} from '@angular/core';
import {ContainersService} from "./containers.service";
import {ContainersModel} from "./containers.model";
import {Global} from "../global";
import {Components} from "../shared/components/components";
import {TranslateService} from '@ngx-translate/core';
import {Router} from "@angular/router";
import {Funcoes} from "../funcoes";
import {LoginService} from "../login/login.service";

declare let swal: any;

@Component({
  selector: 'app-containers',
  templateUrl: './containers.component.html'
})
export class ContainersComponent extends Components implements OnInit {

  containers: ContainersModel[] = [];
  privilegioUsuario = {"editar": false, "consultar": false};

  constructor(
    private containersService: ContainersService,
    public global: Global,
    protected translate: TranslateService,
    protected router: Router,
    public func: Funcoes,
    private loginService: LoginService
  ) {
    super();

    this.loginService.getUserInfo().subscribe(data => {
      for(let i in data.privilegios){
        if(data.privilegios[i].acao[0].url == 'containers'){
          this.privilegioUsuario.consultar = data.privilegios[i].consultar;
          this.privilegioUsuario.editar = data.privilegios[i].editar;
        }
      }
    });
  }

  ngOnInit() {
    this.carregandoTabela = true;
    this.containersService.getPaginacao(1,this.itensPorPagina)
      .subscribe(data => {
        this.containers = data['Payload']['data'];
        this.totalItens = data['Payload']['total'];
        this.carregandoTabela = false;

        if (this.global.debug) {
          console.log(this.containers);
        }
      },
      error => {
        this.func.showErro(error.json());
        this.carregandoTabela = false;
      });


  }

  delete(container) {
    let containers = this.containers;
    let containersService = this.containersService;
    swal({
        title: this.func.traduzir('front.voceTemCerteza'),
        text: this.func.traduzir('front.desejaDeletarContainer')+container.tipo+" / "+container.tamanho,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: 'btn-danger',
        confirmButtonText: this.func.traduzir('front.confirmar'),
        cancelButtonText: this.func.traduzir('front.cancelar'),
        closeOnConfirm: true
      },
      function(){
        if(this.global.debug == true){
          console.log(containers);
        }

        let index = containers.indexOf(container);
        containers.splice(index, 1);

        containersService.apagar(container.id)
          .subscribe(res => {
              //swal(this.func.traduzir('front.deletado'), this.func.traduzir('front.removidoComSucesso'), "success");
              this.containers = containers;
            },
            err => {
              // Revert the view back to its original state
              containers.splice(index, 0, container);
              this.containers = containers;

              this.func.showErro(err.json());
            });

      });
  }

  getPage(pagina){
    this.paginaAtual = pagina;
    this.carregandoTabela = true;
    this.containersService.getPaginacao(pagina,this.itensPorPagina)
      .subscribe(data => {
        this.containers = data['Payload']['data'];
        this.totalItens = data['Payload']['total'];
        this.carregandoTabela = false;
      },
      error => {
        this.func.showErro(error.json());
        this.carregandoTabela = false;
      });
  }

}



// WEBPACK FOOTER //
// ./src/app/containers/containers.component.ts